import { ValidatorFn, AbstractControl, FormArray } from '@angular/forms';

// Array Validators
export class ArrayValidators {

  // max length
  public static maxLength(max: number): ValidatorFn | any {
    return (control: AbstractControl[]) => {
      if (!(control instanceof FormArray)) {
        return null;
      }
      return control.length > max ? { maxLength: true } : null;
    };
  }

  // min length
  public static minLength(min: number): ValidatorFn | any {
    return (control: AbstractControl[]) => {
      if (!(control instanceof FormArray)) {
        return null;
      }
      return control.length < min ? { minLength: true } : null;
    };
  }

  public static atLeastOneSelected(key: string): ValidatorFn | any  {
    return (control: AbstractControl[]) => {
      if (!(control instanceof FormArray)) {
        return null;
      }
      const hasSelected = control.controls.some(group => {
        const field = group.get(key);
        return field ? field.value === true : false;
      });

      return hasSelected ? null : { atLeastOneRequired: true };
    };
  }

}
